import { Dispatch, FC, SetStateAction } from "react";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import { CSSClassesList } from "../../../../helpers/helperTypes";
import { processAndStageStylesV2 } from "../../../../../../_metronic/layout";
import { useFormContext } from "react-hook-form";
import { BeefIntervention } from "../../../../models/Intervention/BeefIntervention";
import { DsmGrid } from "@dsm-dcs/design-system-react";
import ReactHookDsmInput from "../../../../../modules/Helpers/ReactHookDsmInput2";
import { FormType } from "../../common";
import { BeefInputBreeding } from "../../../../models/Baseline/BeefBaseline";
import { UserProfilePrefs } from "../../../../../modules/Helpers/UserProfilePrefs";
import { unitLong } from "../../../../utils/unit-utils";
import EditModeButtons from "../../../helpers/EditModeButtons";
import RowTextFieldWithMetrics from "../../../../../modules/Farms/Intervention/RowControlledTextFieldWithMetrics2";
import { isFieldFilled } from "../CommonDataParts/InterventionGenericInfoDialog";
import { Spacer } from "../../../helpers/Spacer";

interface BeefInputBreedingCalvesComponentProps {
  formType: FormType;
  fieldItemPrefix: string;
  defaultStageData: BeefInputBreeding;
  isCalvesEdit: boolean;
  setIsCalvesEdit: Dispatch<SetStateAction<boolean>>;
  calvesCancelHandler: (isInnerCancel?: boolean) => void;
}

const BeefInputBreedingCalvesComponent: FC<BeefInputBreedingCalvesComponentProps> = ({
  formType,
  fieldItemPrefix,
  defaultStageData,
  isCalvesEdit,
  setIsCalvesEdit,
  calvesCancelHandler,
}) => {
  const intl = useIntl();
  const classes: CSSClassesList = processAndStageStylesV2();
  const userProfile = UserProfilePrefs.getInstance();
  const userUOM = userProfile.getUserUnitPrefs();

  const fc = useFormContext<BeefIntervention>();

  return (
    <>
      <p className={classes.headingTitleVariant}>
        {intl.formatMessage({
          id: 'SUSTELL.STAGE.BEEF.INPUT.CALVES',
        })}
      </p>
      <DsmGrid className={classes.dsmGridOneColumnWithBorder}>
        <Spacer />
        <DsmGrid className={classes.dsmGridTwoColumnNoRowSpacing}>
          {!isCalvesEdit ? (
            <>
              {isFieldFilled(fc.getValues(`${fieldItemPrefix}.averageWeightAtBirth`)) ? (
                <RowTextFieldWithMetrics
                  name={`${fieldItemPrefix}.averageWeightAtBirth`}
                  label={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_BIRTH' })}
                  tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_BIRTH.TOOLTIP' })}
                  baseline={defaultStageData.averageWeightAtBirth}
                  displayTypeSelect={false}
                  type="number"
                  metricUnit={intl.formatMessage(
                    { id: 'SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_BIRTH.ADORNMENT' },
                    { unit: userUOM?.unitOutputMass ? unitLong(userUOM.unitOutputMass) : 'kg' }
                  )}
                  disabled
                />
              ) : (
                <ReactHookDsmInput
                  name={`${fieldItemPrefix}.originalAverageWeightAtBirth`}
                  label={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_BIRTH' })}
                  tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_BIRTH.TOOLTIP' })}
                  adornment={intl.formatMessage(
                    { id: 'SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_BIRTH.ADORNMENT' },
                    { unit: userUOM?.unitOutputMass ? unitLong(userUOM.unitOutputMass) : 'kg' }
                  )}
                  defaultValue={defaultStageData.averageWeightAtBirth}
                  disabled
                />
              )}
              {isFieldFilled(fc.getValues(`${fieldItemPrefix}.permanencePeriod`)) ? (
                <RowTextFieldWithMetrics
                  name={`${fieldItemPrefix}.permanencePeriod`}
                  label={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.PERMANENCE_PERIOD' })}
                  tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.PERMANENCE_PERIOD.TOOLTIP' })}
                  baseline={defaultStageData.averageWeightAtBirth}
                  displayTypeSelect={false}
                  type="number"
                  metricUnit={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.PERMANENCE_PERIOD.ADORNMENT' })}
                  disabled
                />
              ) : (
                <ReactHookDsmInput
                  name={`${fieldItemPrefix}.originalPermanencePeriod`}
                  label={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.PERMANENCE_PERIOD' })}
                  tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.PERMANENCE_PERIOD.TOOLTIP' })}
                  adornment={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.PERMANENCE_PERIOD.ADORNMENT' })}
                  defaultValue={defaultStageData.permanencePeriod}
                  disabled
                />
              )}
            </>
          ) : (
            <>
              <RowTextFieldWithMetrics
                name={`${fieldItemPrefix}.averageWeightAtBirth`}
                label={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_BIRTH' })}
                tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_BIRTH.TOOLTIP' })}
                baseline={defaultStageData.averageWeightAtBirth}
                type="number"
                metricUnit={intl.formatMessage(
                  { id: 'SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_BIRTH.ADORNMENT' },
                  { unit: userUOM?.unitOutputMass ? unitLong(userUOM.unitOutputMass) : 'kg' }
                )}
                disabled={false}
              />
              <RowTextFieldWithMetrics
                name={`${fieldItemPrefix}.permanencePeriod`}
                label={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.PERMANENCE_PERIOD' })}
                tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.PERMANENCE_PERIOD.TOOLTIP' })}
                baseline={defaultStageData.averageWeightAtBirth}
                type="number"
                metricUnit={intl.formatMessage({ id: 'SUSTELL.STAGE.BEEF.INPUT.PERMANENCE_PERIOD.ADORNMENT' })}
                disabled={false}
              />
            </>
          )}


        </DsmGrid>
        {formType !== FormType.View &&
          <EditModeButtons
            isEditing={isCalvesEdit}
            onEdit={() => setIsCalvesEdit(true)}
            onCancel={calvesCancelHandler}
          />}
      </DsmGrid >
    </>
  )
}

export default BeefInputBreedingCalvesComponent;
